import React, {Component} from 'react';
import {observer,inject} from "mobx-react";
import {makeObservable,observable,toJS} from "mobx";
import { DropTarget, DragDropContainer } from 'react-drag-drop-container';

class FieldDropTarget extends Component {
  drag_enter=false;

  constructor(props) {
    super(props);
    makeObservable(this,{
      drag_enter:observable,
    });
  }
  renderHover() {
    const width=this.props.width || 5;
    const height=this.props.height || 5;

    if(this.props.position === "top") {
      return (
        <div className="pa pa-tl w100" style={{height:'50%', zIndex:60}}>
          <div className={`pa pa-tl w100 ${this.drag_enter?"bg-pc1-op80":""}`} style={{ height: height, top:-height, zIndex:60 }}></div>
        </div>
      )
    }
    if(this.props.position === "right") {
      return (
        <div className="pa pa-tr h100" style={{width:'50%', zIndex:60}}>
          <div className={`pa pa-tr h100 ${this.drag_enter?"bg-pc1-op80":""}`} style={{ width: width, zIndex:60, right:-width }}></div>
        </div>
      )
    }
    if(this.props.position === "left") {
      return (
        <div className="pa pa-tl h100" style={{width:'50%', zIndex:60}}>
          <div className={`pa pa-tl h100 ${this.drag_enter?"bg-pc1-op80":""}`} style={{ width: width, zIndex:60,left:-width }}></div>
        </div>
      )
    }
    if(this.props.position === "bottom") {
      return (
        <div className="pa pa-bl w100" style={{height:'50%', zIndex:60}}>
          <div className={`pa pa-bl w100 ${this.drag_enter?"bg-pc1-op80":""}`} style={{ height: height, bottom: -height, zIndex:60 }}></div>
        </div>
      )
    }

    return (
      <div>
        nothing?
      </div>
    )
  }
  render() {
    return (

      <DropTarget
        onDragEnter={()=>{
          this.drag_enter=true;
        }}
        onDragLeave={()=>{
          this.drag_enter=false;
        }}
        onHit={(e)=>{
          this.drag_enter=false;
          this.props.onDrop(this.props.item, e.dragData.source, this.props.position);
        }}
        targetKey="general"
      >
        {this.renderHover()}
      </DropTarget>

    )
  }
}

export default observer(FieldDropTarget);